import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { CALENDLY_URL, ASSESSMENT_URL } from "@/config";

export function BookCallButton({ testid, dark = false, className = "", label = "Book an Intro Call" }) {
  return (
    <motion.a
      data-testid={testid}
      href={CALENDLY_URL}
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.25 }}
      className={`group inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 text-sm font-semibold tracking-wide transition-colors duration-300 ${
        dark
          ? "bg-amber text-paper hover:bg-amber-dark"
          : "bg-ink text-paper hover:bg-amber"
      } ${className}`}
    >
      {label}
      <ArrowUpRight
        size={16}
        className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </motion.a>
  );
}

export function AssessmentButton({ testid, dark = true, className = "" }) {
  return (
    <motion.a
      data-testid={testid}
      href={ASSESSMENT_URL}
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.25 }}
      className={`group inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 text-sm font-semibold tracking-wide transition-colors duration-300 ${
        dark
          ? "bg-amber text-paper hover:bg-amber-dark"
          : "bg-ink text-paper hover:bg-amber"
      } ${className}`}
    >
      Take the Free Assessment
      <ArrowRight
        size={16}
        className="transition-transform duration-300 group-hover:translate-x-0.5"
      />
    </motion.a>
  );
}

export function GhostLink({ testid, href, children, onClick, dark = false, external = false }) {
  return (
    <a
      data-testid={testid}
      href={href}
      onClick={onClick}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      className={`group inline-flex items-center gap-2 border-b pb-1 text-sm font-semibold tracking-wide transition-colors duration-300 ${
        dark
          ? "border-paper/30 text-paper hover:border-amber hover:text-amber"
          : "border-ink/30 text-ink hover:border-amber hover:text-amber"
      }`}
    >
      {children}
      <ArrowUpRight
        size={15}
        className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </a>
  );
}

export function ContactLink({ testid, dark = false }) {
  return (
    <RouterLink
      data-testid={testid}
      to="/contact"
      className={`group inline-flex items-center gap-2 border-b pb-1 text-sm font-semibold tracking-wide transition-colors duration-300 ${
        dark
          ? "border-paper/30 text-paper hover:border-amber hover:text-amber"
          : "border-ink/30 text-ink hover:border-amber hover:text-amber"
      }`}
    >
      Get in Touch
      <ArrowUpRight
        size={15}
        className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </RouterLink>
  );
}
